import React from "react";
import { CompactTable } from "@table-library/react-table-library/compact";
import { useTheme } from "@table-library/react-table-library/theme";
import { useTree } from "@table-library/react-table-library/tree";
//import { DEFAULT_OPTIONS, getTheme } from '@table-library/react-table-library/mantine';
import {
  DEFAULT_OPTIONS,
  getTheme,
} from "@table-library/react-table-library/material-ui";
import { Box, Button, CircularProgress } from "@mui/material";
import { useSort } from "@table-library/react-table-library/sort";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardIcon from "@mui/icons-material/Keyboard";
import "./DataTable.css";
import { isMobile } from "app/utils/utils";

const DataTable = ({
  columns,
  rows,
  filterSort,
  contentHeight,
  dataTree,
  nodeChangeHandler,
  sorting,
  hasCustomWidth,
}) => {
  const mantineTheme = getTheme(DEFAULT_OPTIONS, { isVirtualized: true });
  let customColumnWidth = "";
  let defaultColumnWidth = [];
  if (hasCustomWidth) {
    for (let i = 0; i < columns.length; i++) {
      var columnInfo = columns[i];
      if (columnInfo.width && columnInfo.width != "") {
        defaultColumnWidth.push(columnInfo.width);
      } else {
        defaultColumnWidth.push("minmax(0px, 1fr)");
      }
    }
  } else {
    for (let i = 0; i < columns.length; i++) {
      defaultColumnWidth.push("minmax(0px, 1fr)");
    }
  }
  customColumnWidth = defaultColumnWidth.join(" ");
  const customTheme = {
    Table:
      "border-top:1px solid #d4d4d4; max-height:" +
      contentHeight +
      "px; overflow:auto;  --data-table-library_grid-template-columns:" +
      customColumnWidth +
      " ",
    HeaderRow: `
        .th {
          border-bottom: 1px solid #d4d4d4;
          height:54px;
          font-weight:600;
        }
      `,
    Row: `
        &:not(:last-of-type) .td {
          border-bottom: 1px solid #d4d4d4;
        }
      `,
    BaseCell: `
        &:not(:last-of-type) {
          border-right: 1px solid #d4d4d4;
          
        }
        padding:8px 16px;
        `,
  };
  const theme = useTheme([mantineTheme, customTheme]);
  const data = { nodes: rows };

  const sort = useSort(
    data,
    {
      state: {
        sortKey: sorting && sorting.key ? sorting.key : "",
        reverse:
          sorting && sorting.type && sorting.type == "ASC" ? true : false,
      },
      onChange: onSortChange,
    },
    {
      sortIcon: {
        iconDefault: null,
        iconUp: <KeyboardArrowUpIcon />,
        iconDown: <KeyboardArrowDownIcon />,
      },

      sortFns: filterSort,
    }
  );

  const tree = useTree(
    data,
    {
      onChange: onTreeChange,
    },
    {
      treeIcon: {
        iconDefault: null,
        iconRight: <KeyboardArrowRightIcon />,
        iconDown: <KeyboardArrowDownIcon />,
      },
    }
  );
  function onTreeChange(action, state) {
    if ((nodeChangeHandler, action.type == "ADD_BY_ID")) {
      const rowData = rows.find((o) => o.id === action.payload.id);
      if (rowData.nodes.length == 0) {
        nodeChangeHandler(action.payload.id);
      }
    }
    //console.log(action, state);
  }

  function onSortChange(action, state) {
    //console.log(action, state);
  }
  return (
    <Box>
      <CompactTable
        columns={columns}
        data={data}
        theme={theme}
        sort={sort}
        tree={dataTree ? tree : false}
        layout={{ isDiv: true, fixedHeader: true, custom: true }}
      />
    </Box>
  );
};

export default DataTable;
